module.exports = __webpack_public_path__ + "static/media/Artboard 1 copy 100.b6be343e.png";